/* global SWDLocalise */
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import history from 'instantsearch.js/es/lib/routers/history';
import { stats } from 'instantsearch.js/es/widgets';
import { connectMenu, connectToggleRefinement } from 'instantsearch.js/es/connectors';
import customClearRefinements from './widgets/clear-refinements';
import customMenuSelect from './widgets/menu-select';
import customMenuSelectTyreCategory from './widgets/menu-select-tyre-category';
import customHits from './widgets/hits';
import searchByVRM from './search-by-vrm';
import searchByModel from './search-by-model';
import { capFirstLetter } from '../../utils';

const searchResults = document.querySelector('.js-search-results');
const searchBtns = document.querySelectorAll('.js-search-btn');

let firstRender = false;

const setup = () => {
    const algoliaClient = algoliasearch(
        SWDLocalise.algoliaAppID,
        SWDLocalise.algoliaAPIKey,
    );

    const searchClient = {
        ...algoliaClient,
    };

    const indexName = `${SWDLocalise.algoliaIndex}tyre`;

    const search = instantsearch({
        searchClient,
        indexName,
        routing: {
            router: history({
                createURL({ qsModule, routeState, location }) {
                    const queryParameters = {};

                    // run flat
                    // if (routeState.runflat) {
                    //     queryParameters.runflat = true;
                    // }

                    // type
                    if (routeState.tyre_type) {
                        queryParameters.type = routeState.tyre_type;
                    }

                    // season
                    if (routeState.tyre_season) {
                        queryParameters.season = routeState.tyre_season;
                    }

                    // section
                    if (routeState.section) {
                        queryParameters.section = routeState.section;
                    }

                    // profile
                    if (routeState.profile) {
                        queryParameters.profile = routeState.profile;
                    }

                    // rim
                    if (routeState.rim) {
                        queryParameters.rim = routeState.rim;
                    }

                    // load
                    if (routeState.load) {
                        queryParameters.load = routeState.load;
                    }

                    // speed
                    if (routeState.speed) {
                        queryParameters.speed = routeState.speed;
                    }

                    const queryString = qsModule.stringify(queryParameters, {
                        addQueryPrefix: true,
                        arrayFormat: 'repeat',
                    });

                    // update search button href with params
                    if (searchBtns.length > 0) {
                        searchBtns.forEach((btn) => {
                            btn.setAttribute('href', `${location.origin}/tyre-range/${queryString}`);
                        });
                    }

                    return `${location.origin + location.pathname + queryString}`;
                },

                parseURL({ qsModule, location }) {
                    const {
                        type = '',
                        section = '',
                        profile = '',
                        rim = '',
                        load = '',
                        speed = '',
                        season = '',
                        // runflat = false,
                    } = qsModule.parse(
                        location.search.slice(1),
                    );

                    // update search button href with params
                    if (searchBtns.length > 0) {
                        searchBtns.forEach((btn) => {
                            btn.setAttribute('href', `${location.origin}/tyre-range/${location.search}`);
                        });
                    }

                    return {
                        tyre_type: type,
                        tyre_season: season,
                        section,
                        profile,
                        rim,
                        load,
                        speed,
                        // runflat: (runflat ? true : ''),
                    };
                },

                cleanUrlOnDispose: false,
            }),

            stateMapping: {
                stateToRoute(uiState) {
                    const indexUiState = uiState.wp_tyre || {};
                    // let { runflat } = '';

                    // if (indexUiState.toggle) {
                    //     Object.keys(indexUiState.toggle).forEach((key) => {
                    //         if (key === 'runflat') {
                    //             runflat = indexUiState.toggle[key];
                    //         }
                    //     });
                    // }

                    return {
                        section: indexUiState.menu && indexUiState.menu.section,
                        profile: indexUiState.menu && indexUiState.menu.profile,
                        rim: indexUiState.menu && indexUiState.menu.rim,
                        load: indexUiState.menu && indexUiState.menu.load,
                        speed: indexUiState.menu && indexUiState.menu.speed,
                        tyre_type: indexUiState.menu && indexUiState.menu['taxonomies.tyre_type'],
                        tyre_season: indexUiState.menu && indexUiState.menu['taxonomies.tyre_season'],
                        // runflat,
                    };
                },

                routeToState(routeState) {
                    return {
                        wp_tyre: {
                            menu: {
                                section: routeState.section,
                                profile: routeState.profile,
                                rim: routeState.rim,
                                load: routeState.load,
                                speed: routeState.speed,
                                'taxonomies.tyre_type': routeState.tyre_type,
                                'taxonomies.tyre_season': routeState.tyre_season,
                            },
                            // toggle: {
                            //     runflat: routeState.runflat,
                            // },
                        },
                    };
                },
            },
        },
        searchFunction(helper) {
            if (!firstRender) {
                // preselect season
                if (searchResults
                    && searchResults.dataset.season !== undefined) {
                    helper
                        .clearRefinements('taxonomies.tyre_season')
                        .toggleFacetRefinement('taxonomies.tyre_season', searchResults.dataset.season);
                }

                // preselect type
                if (searchResults
                    && searchResults.dataset.type !== undefined) {
                    helper
                        .clearRefinements('taxonomies.tyre_type')
                        .toggleFacetRefinement('taxonomies.tyre_type', searchResults.dataset.type);
                }

                firstRender = true;
            }

            helper.search();
        },
        // onStateChange({ uiState, setUiState }) {
        //     if (!firstRender) {
        //         const newState = { ...uiState };

        //         // preselect season
        //         if (searchResults && searchResults.dataset.season !== undefined) {
        //             newState[indexName] = {
        //                 ...newState[indexName],
        //                 menu: {
        //                     ...newState[indexName]?.menu,
        //                     'taxonomies.tyre_season': searchResults.dataset.season,
        //                 },
        //             };
        //         }

        //         // preselect type
        //         if (searchResults && searchResults.dataset.type !== undefined) {
        //             newState[indexName] = {
        //                 ...newState[indexName],
        //                 menu: {
        //                     ...newState[indexName]?.menu,
        //                     'taxonomies.tyre_type': searchResults.dataset.type,
        //                 },
        //             };
        //         }

        //         firstRender = true;
        //         setUiState(newState);
        //     }
        // },
        future: {
            preserveSharedStateOnUnmount: true,
        },
    });

    const clearRefinements = document.querySelector('.js-search-form-clear');
    if (clearRefinements) {
        search.addWidgets([
            customClearRefinements({
                container: clearRefinements,
                excludedAttributes: ['id'],
            }),

            customMenuSelect({
                container: document.querySelector('.js-search-form-filter-section'),
                attribute: 'section',
                limit: 100,
                transformItems(items) {
                    return items.sort((a, b) => a.value - b.value);
                },
            }),

            customMenuSelect({
                container: document.querySelector('.js-search-form-filter-profile'),
                attribute: 'profile',
                limit: 100,
            }),

            customMenuSelect({
                container: document.querySelector('.js-search-form-filter-rim'),
                attribute: 'rim',
                limit: 100,
            }),

            customMenuSelect({
                container: document.querySelector('.js-search-form-filter-load'),
                attribute: 'load',
                limit: 100,
                sortBy(a, b) {
                    const aName = Number(a.name.split('/')[0]);
                    const bName = Number(b.name.split('/')[0]);

                    if (aName < bName) return -1;
                    if (aName > bName) return 1;

                    return 0;
                },
            }),

            customMenuSelect({
                container: document.querySelector('.js-search-form-filter-speed'),
                attribute: 'speed',
                limit: 100,
            }),
        ]);
    }

    const searchStats = document.querySelector('.js-search-stats');
    if (searchStats) {
        search.addWidgets([
            stats({
                container: searchStats,
                templates: {
                    text(data, { html }) {
                        let count = '';

                        if (data.hasManyResults) {
                            count += `${data.nbHits} tyres`;
                        } else if (data.hasOneResult) {
                            count += '1 tyre';
                        } else {
                            count += 'No tyres';
                        }

                        return html`${count}`;
                    },
                },
            }),
        ]);
    }

    if (searchResults) {
        search.addWidgets([
            // toggleRefinement({
            //     container: document.querySelector('.js-search-form-filter-run-flat'),
            //     attribute: 'runflat',
            //     templates: {
            //         labelText(data, { html }) {
            //             return html`Runflat`;
            //         },
            //     },
            // }),

            customHits({
                container: searchResults,
            }),
        ]);

        // preselect season
        if (searchResults
            && searchResults.dataset.season !== undefined) {
            const virtualSeasonMenu = connectMenu(() => null);
            search.addWidgets([
                virtualSeasonMenu({
                    attribute: 'taxonomies.tyre_season',
                }),
            ]);
        } else {
            search.addWidgets([
                customMenuSelectTyreCategory({
                    container: document.querySelector('.js-search-form-filter-season'),
                    attribute: 'taxonomies.tyre_season',
                    sortBy: ['name:asc'],
                    transformItems(items) {
                        return items.map((item) => ({
                            ...item,
                            label: item.label.split('-')
                                .map(decodeURIComponent)
                                .map(capFirstLetter)
                                .join(' '),
                        }));
                    },
                    title: 'Season',
                }),
            ]);
        }

        // preselect type
        if (searchResults
            && searchResults.dataset.type !== undefined) {
            const virtualTypeMenu = connectMenu(() => null);
            search.addWidgets([
                virtualTypeMenu({
                    attribute: 'taxonomies.tyre_type',
                }),
            ]);
        } else {
            search.addWidgets([
                customMenuSelectTyreCategory({
                    container: document.querySelector('.js-search-form-filter-type'),
                    attribute: 'taxonomies.tyre_type',
                    sortBy: ['name:asc'],
                    transformItems(items) {
                        return items.map((item) => ({
                            ...item,
                            label: item.label.split('-')
                                .map(decodeURIComponent)
                                .map(capFirstLetter)
                                .join(' '),
                        }));
                    },
                    title: 'Purpose',
                }),
            ]);
        }
    } else {
        const virtualToggleRefinement = connectToggleRefinement(() => null);
        search.addWidgets([
            virtualToggleRefinement({
                attribute: 'runflat',
            }),
        ]);
    }

    search.start();

    // init search by VRM
    searchByVRM(search);

    // init search by model
    searchByModel(search);
};

const init = () => {
    if (!document.querySelector('.js-search-form')) return;
    setup();
};

export default init;
